import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

const shell =
  'relative overflow-hidden rounded-2xl border border-border bg-card text-card-foreground shadow-[var(--shadow-card)] transition-[box-shadow,border-color] duration-200'

export function Card({
  children,
  className = '',
  padding = true,
  hover = false,
  accent = false,
}: {
  children: ReactNode
  className?: string
  padding?: boolean
  hover?: boolean
  accent?: boolean
}) {
  return (
    <div
      className={cn(
        shell,
        hover && 'hover:border-border hover:shadow-[var(--shadow-soft)]',
        padding && 'p-6 sm:p-7',
        className,
      )}
    >
      {accent ? (
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/35 to-transparent"
          aria-hidden
        />
      ) : null}
      {children}
    </div>
  )
}

export function CardHeader({
  title,
  eyebrow,
  description,
  action = null,
}: {
  title?: string
  eyebrow?: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div
      className={cn(
        'mb-6 flex border-b border-border pb-6',
        action
          ? 'flex-row flex-wrap items-start justify-between gap-4'
          : 'flex-col gap-4 sm:flex-row sm:items-start sm:justify-between',
      )}
    >
      <div className="min-w-0">
        {eyebrow ? (
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">{eyebrow}</p>
        ) : null}
        {title ? (
          <h2
            className={cn(
              'text-xl font-semibold tracking-tight text-foreground sm:text-[1.35rem] sm:leading-snug',
              eyebrow && 'mt-2',
            )}
          >
            {title}
          </h2>
        ) : null}
        {description ? (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  )
}
